import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { siteConfig } from '../mock';

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? 'bg-black/40 backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-24 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 select-none">
          <span
            className="font-serif italic text-white text-4xl leading-none"
            style={{ letterSpacing: '-0.02em' }}
          >
            u<span className="align-super text-xl -ml-0.5">o</span>
          </span>
          <span
            className="hidden sm:block text-white text-[10px] tracking-[0.35em] font-sans font-semibold border-l border-white/40 pl-2 leading-tight"
          >
            URBAN
            <br />
            OUTSOURCING
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {siteConfig.nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `text-white text-[13px] tracking-[0.22em] font-sans font-medium hover:opacity-70 transition-opacity ${
                  isActive ? 'opacity-100' : 'opacity-90'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to={siteConfig.cta.to}
            className="text-white text-[13px] tracking-[0.22em] font-sans font-medium border border-white/80 rounded-full px-6 py-2.5 hover:bg-white hover:text-neutral-800 transition-colors"
          >
            {siteConfig.cta.label}
          </Link>
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden bg-black/85 backdrop-blur-md border-t border-white/10">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {siteConfig.nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className="text-white text-sm tracking-[0.22em] font-sans font-medium"
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to={siteConfig.cta.to}
              className="self-start text-white text-sm tracking-[0.22em] font-sans font-medium border border-white/80 rounded-full px-6 py-2.5"
            >
              {siteConfig.cta.label}
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
